import { attachTabSync } from '@rocketlane/state-db';
import { getTabSync } from '../tab-sync';
import { phaseCollection } from './phase-collection';
/**
 * Bind the phase collection to the cross-tab channel.
 *
 * `merge` mode (the adapter's default), for the same reason as
 * `collections/project/tab-sync.ts`: a phase is fetched at several fidelities
 * (detail-embedded, board, dropdown-list), so a peer whose newest value came
 * from a lower-fidelity fetch must not replace a fuller one here.
 *
 * This is the gap-fix the migration exists for: phase field/date/status/
 * private edits have NO cross-tab signal today — the hand-rolled
 * `patchProjectPhaseInStores` only ever writes `source: 'local'`. Once phase
 * is its own collection, every edit propagates for free.
 */ export const attachPhaseTabSync = ()=>attachTabSync({
        collection: phaseCollection,
        sync: getTabSync()
    });
